import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2c6e1bdf&"
import script from "@/scripts/dashboard/dashboard.js?vue&type=script&lang=js&"
export * from "@/scripts/dashboard/dashboard.js?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports